import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUpdateAllowedEntityTypeAndIdsMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { GET_APP_GOVERNANCE_PERMISSIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.dfc.new';
import { useCaptureError } from '../useCaptureError';
import { jsx as _jsx } from "react/jsx-runtime";
export function useUpdateAllowedEntityTypeAndIds() {
  const [mutate, {
    loading,
    error
  }] = useUpdateAllowedEntityTypeAndIdsMutation();
  useCaptureError(error, {
    message: 'Error updating install permissions',
    alert: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.errorBoundary.default.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.installPermissions.saveChanges.error"
      })
    }
  });
  const updateAllowedEntityTypeAndIds = ({
    variables
  }) => {
    var _variables$entityType;
    return mutate({
      variables: Object.assign({}, variables, {
        entityTypeAndIds: (_variables$entityType = variables.entityTypeAndIds) !== null && _variables$entityType !== void 0 ? _variables$entityType : []
      }),
      refetchQueries: [GET_APP_GOVERNANCE_PERMISSIONS_QUERY]
    });
  };
  return {
    updateAllowedEntityTypeAndIds,
    loading,
    error
  };
}